import { useState } from "react";

import { sourceCreateCapi } from "helpers/Sources/createSource";

import SwalAlertComp from "components/SwalAlert";

const EMPTY_APP_CAPI = { appCapiName: "" };

/**
 * Android / iOS CAPI flow: a single package name field.
 */
const useAppCapiSource = ({ sourceType, language, usage, onCreated }) => {
    const [appCapi, setAppCapi] = useState(EMPTY_APP_CAPI);
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const reset = () => {
        setAppCapi(EMPTY_APP_CAPI);
        setError("");
        setIsLoading(false);
    };

    const create = async () => {
        if (isLoading) return;
        if (!appCapi?.appCapiName) {
            setError(
                language?.tracker_wizard?.cannot_be_blank ?? "Cannot be blank!",
            );
            return;
        }
        setIsLoading(true);
        try {
            const response = await sourceCreateCapi({
                domain: appCapi?.appCapiName,
                source_type: sourceType,
                usage_types: usage,
            });
            if (response.status) {
                SwalAlertComp({
                    title: language?.delete_swal_modal?.success ?? "Success",
                    message: response.message && response.message,
                    icon: "success",
                    timer: 3000,
                });
                setAppCapi(EMPTY_APP_CAPI);
                await onCreated({
                    sourceId: response?.data?.id,
                    sourceType,
                    sourceTypeId: response?.data?.source_type_id,
                });
            } else {
                SwalAlertComp({
                    title: language?.delete_swal_modal?.failed ?? "Failed",
                    message: response?.message ?? "",
                    icon: "error",
                });
            }
        } finally {
            setIsLoading(false);
        }
    };

    return { appCapi, setAppCapi, error, setError, isLoading, create, reset };
};

export default useAppCapiSource;
